import { render, staticRenderFns } from "./applicationDetail.vue?vue&type=template&id=087bb026&scoped=true&"
import script from "./applicationDetail.vue?vue&type=script&lang=js&"
export * from "./applicationDetail.vue?vue&type=script&lang=js&"
import style0 from "./applicationDetail.vue?vue&type=style&index=0&id=087bb026&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087bb026",
  null
  
)

export default component.exports